import React from 'react';

const ANIMATION_NAME = 'ee-magic-shiny';

const KEYFRAMES = `@keyframes ${ANIMATION_NAME} {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}`;

/**
 * Web version of the mobile `MagicShiny` card from `@easy-expense/ui-shared-components`: a
 * pressable card with a slowly shifting purple / coral / amber glow behind a translucent white
 * face. The mobile one is built on expo-linear-gradient and Animated, so this redoes the same look
 * with a CSS gradient and keyframes. The face is a div rather than a `Layout.Pressable*` (a
 * `<button>`) so it fills the whole card and can hold its own buttons.
 */
export const MagicShiny: React.FC<React.PropsWithChildren<{ onClick: () => void }>> = ({
  children,
  onClick,
}) => {
  function onKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick();
    }
  }

  return (
    <div
      style={{
        padding: 2,
        borderRadius: 12,
        background: 'linear-gradient(90deg, #9c40ff99, #ff6e5a99, #ffb85f99, #ff6e5a99, #9c40ff99)',
        backgroundSize: '300% 100%',
        animation: `${ANIMATION_NAME} 6s linear infinite`,
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
      }}
    >
      <style>{KEYFRAMES}</style>
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={onKeyDown}
        style={{ backgroundColor: '#ffffff90', borderRadius: 10, cursor: 'pointer' }}
      >
        {children}
      </div>
    </div>
  );
};
